import { render, staticRenderFns } from "./StepsSwitch.vue?vue&type=template&id=10328814&scoped=true&"
import script from "./StepsSwitch.vue?vue&type=script&lang=js&"
export * from "./StepsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./StepsSwitch.vue?vue&type=style&index=0&id=10328814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10328814",
  null
  
)

export default component.exports